import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { useI18n } from '../I18nContext';
import { Shield } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

function ProtectedRoute({ children }) {
  const { farmer, loading } = useAuth();
  const { t } = useI18n();

  if (loading) return <div className="text-center py-16 text-text-muted">{t('common.loading')}</div>;

  if (!farmer) {
    return (
      <div className="max-w-sm mx-auto mt-20 px-6">
        <Card>
          <CardContent className="text-center py-8">
            <Shield size={48} className="text-text-light mx-auto mb-4 block" />
            <h2 className="text-text-primary m-0 mb-2 text-xl font-bold">{t('protected.signInRequired')}</h2>
            <p className="text-text-muted text-sm mb-6">{t('protected.description')}</p>
            <div className="flex gap-2 justify-center">
              <Button asChild variant="default" size="md">
                <Link to="/login">{t('nav.login')}</Link>
              </Button>
              <Button asChild variant="outline" size="md">
                <Link to="/register">{t('nav.register')}</Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }
  return children;
}

export default ProtectedRoute;
